<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Autorizações Vencidas</h2>
    </div>

    <tds-accordion>
        <!-- Filtros -->
        <tds-accordion-item header="Filtros" aria-level="6" expanded>
            <div class="tds-row">
                <tds-text-field type="text" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Solicitação" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px; width: 20%"></tds-text-field>
                <tds-text-field type="text" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Cliente" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px; width: 35%"></tds-text-field>
            </div>
            <div class="tds-row" style="padding-top: 20px; justify-content: center">
                <tds-button type="button" variant="primary" size="lg" text="Pesquisar" animation="none" tds-aria-label="undefined" name="" value="" style="padding-right: 5px;"></tds-button>
                <tds-button type="button" variant="secondary" size="lg" text="Limpar" animation="none" tds-aria-label="undefined" name="" value="" style="padding-right: 5px;"></tds-button>
            </div>
        </tds-accordion-item>

        <!-- Tabela -->
        <tds-accordion-item header="Tabela" aria-level="6" expanded>
            <div class="tds-row">
                <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width>
                    <tds-table-toolbar>
                        <div slot="end" class="tds-u-flex tds-u-align-items-center tds-u-h-100 tds-u-gap1" style="margin-left: 8px;">
                            <tds-button variant="secondary" size="sm" title="Reativar">
                                <tds-icon slot="icon" class="tds-btn-icon" size="18px" name="tick"></tds-icon>
                            </tds-button>
                            <tds-button variant="secondary" size="sm" title="Gerar Relatório">
                                <tds-icon slot="icon" size="18px" name="document_xls"></tds-icon>
                            </tds-button>
                        </div>
                    </tds-table-toolbar>
                    <tds-table-header>
                        <tds-header-cell cell-key="actions"></tds-header-cell>
                        <tds-header-cell cell-key='solic' cell-value='Solicitação' sortable></tds-header-cell>
                        <tds-header-cell cell-key='dataIni' cell-value='Data Início' sortable></tds-header-cell>
                        <tds-header-cell cell-key='cliente' cell-value='Cliente' sortable></tds-header-cell>
                        <tds-header-cell cell-key='dealer' cell-value='Dealer' sortable></tds-header-cell>
                        <tds-header-cell cell-key='modelo' cell-value='Modelo' sortable></tds-header-cell>
                    </tds-table-header>
                    <tds-table-body>
                        <tds-table-body-row>
                            <tds-body-cell cell-key="actions">
                                <tds-checkbox value="checkbox-1" checkbox-id="first-checkbox" tds-aria-label="A checkbox component">
                                </tds-checkbox>
                            </tds-body-cell>
                            <tds-body-cell cell-key="solic">15221</tds-body-cell>
                            <tds-body-cell cell-key="dataIni">17/03/2010</tds-body-cell>
                            <tds-body-cell cell-key="cliente">AUTO POSTO CONFIANCA LTDA - ME</tds-body-cell>
                            <tds-body-cell cell-key="dealer">MCM GROUP (254)</tds-body-cell>
                            <tds-body-cell cell-key="modelo">R 380 LA4X2 3.EIXO</tds-body-cell>
                        </tds-table-body-row>
                    </tds-table-body>
                </tds-table>
            </div>
        </tds-accordion-item>
    </tds-accordion>
</div>